/**
 * Error model
 * NOTE: ACF is active custom fields plugin from word press
 */
export class Error {
  constructor(
    public modifiedDate: Date,
    public display_notification: boolean,
    public content: string
  ) {}
}
